import { PureComponent, Component } from 'react';
import { useTranslation, withTranslation } from 'react-i18next';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { isMobile, isTablet } from 'react-device-detect';
import { Button, Icon, Modal } from 'semantic-ui-react';
import AvField from 'availity-reactstrap-validation/lib/AvField';
import AvForm from 'availity-reactstrap-validation/lib/AvForm';
import { CKEditor } from '@ckeditor/ckeditor5-react';

import {
  ClassicEditor,
  Bold,
  Essentials,
  Italic,
  Paragraph,
  List,
  Heading,
} from 'ckeditor5';

import addIcon from '../../../../assets/add-icon.svg';

import { map } from '../../../../utils/lodash';
import {
  getHelpPages,
  postHelpPage,
  postHelpTips,
  updateHelpPage,
  getActivityHelpTips,
  putHelpTips,
} from '../../../../store/actions';

import {
  CustomAccordion,
  CustomTable,
  CustomTooltip,
} from '../../../../components';

class ParentHelpComponent extends Component {
  componentDidMount() {
    const { getHelpPages, getActivityHelpTips } = this.props;
    getHelpPages();
    getActivityHelpTips();
  }

  render() {
    return (
      <div>
        <Helps {...this.props} />

        <HelpList {...this.props} />
      </div>
    );
  }
}

export class Helps extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div>
        <div className="outcome-admin-padded-help">
          <div className="add-help-page">
            <div className="add-page-right">
              <AddHelpPage {...this.props} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

class AddHelpTips extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
    };
  }

  toggle() {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  }

  render() {
    const { t } = this.props;
    const { modal } = this.state;

    return (
      <Modal
        open={modal}
        onOpen={() => this.toggle()}
        closeIcon={
          <Icon
            onClick={() => this.toggle()}
            name="close"
            className="closeicon"
          />
        }
        size="small"
        trigger={
          <Button className="Secondary-Button">
            <Icon name="plus" />
            {t('admin.system_settings.helps.add_help_tip')}
          </Button>
        }
        className="create-tip"
      >
        <Modal.Header>
          {t('admin.system_settings.helps.create_tip')}
        </Modal.Header>
        <Modal.Content>
          <HelpTipsModal toggle={() => this.toggle()} {...this.props} />
        </Modal.Content>
      </Modal>
    );
  }
}

class AddHelpPage extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
    };
  }

  toggle() {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  }

  render() {
    const { t } = this.props;
    const { modal } = this.state;

    return (
      <Modal
        open={modal}
        onOpen={() => this.toggle()}
        closeIcon={
          <Icon
            onClick={() => this.toggle()}
            name="close"
            className="closeicon"
          />
        }
        size="small"
        trigger={
          <Button className="Primary-Button">
            <div className="add-icon-activity-add">
              <img className="icons-add" src={addIcon} alt="icon" />
              <div className="add-text">
                {t('admin.system_settings.helps.add_help_page')}
              </div>
            </div>
          </Button>
        }
        className="create-help-page"
      >
        <Modal.Header>
          {t('admin.system_settings.helps.create_help_page')}
        </Modal.Header>
        <Modal.Content>
          <HelpPageFormPost toggle={() => this.toggle()} {...this.props} />
        </Modal.Content>
      </Modal>
    );
  }
}

class HelpPageFormPost extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      content: '',
    };
  }

  async handleValidSubmit(event, values) {
    try {
      const { postHelpPage, toggle } = this.props;
      const { content } = this.state;

      const data = { ...values, content };

      await postHelpPage(data);
      toggle();
    } catch {}
  }

  render() {
    const { t, toggle, hPageLoading } = this.props;

    return (
      <AvForm
        onValidSubmit={(event, values) => this.handleValidSubmit(event, values)}
        className="venue-form"
      >
        <AvField
          label={t('formulary.title')}
          className="org-inputs"
          name="title"
          type="text"
          validate={{
            required: {
              value: true,
              errorMessage: t('formulary.validation.title_required'),
            },
          }}
        />
        <label>{t('formulary.content')}</label>
        <CKEditor
          editor={ClassicEditor}
          data=""
          config={{
            plugins: [Essentials, Bold, Italic, List, Heading, Paragraph],
          }}
          onBlur={(event, editor) => {
            const content = editor.getData();
            this.setState({
              content,
            });
          }}
        />

        <div className="model-buttons">
          <Button
            className="Secondary-Button"
            type="button"
            onClick={() => toggle()}
          >
            {t('actions.cancel')}
          </Button>
          <Button
            content={t('actions.save')}
            type="submit"
            className="Primary-Button"
            loading={hPageLoading}
            disabled={hPageLoading}
          />
        </div>
      </AvForm>
    );
  }
}
class HelpTipsModal extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  helpPageList() {
    const { helpPages } = this.props;
    return map(helpPages, (item, i) => {
      return (
        <option key={i} value={item.id}>
          {item.title}
        </option>
      );
    });
  }

  async handleValidSubmit(event, values) {
    try {
      const { postHelpTips, toggle } = this.props;
      values.content = values.contentTip;
      values.helpPageId = values.id;
      delete values.contentTip;
      delete values.id;

      await postHelpTips(values);
      toggle();
    } catch (error) {
      console.error('Submit', error);
    }
  }

  render() {
    const { t, toggle, hTipLoading, helpPageItem } = this.props;

    return (
      <AvForm
        ref={(c) => (this.form = c)}
        onValidSubmit={(event, values) => this.handleValidSubmit(event, values)}
        className="venue-form"
        model={helpPageItem}
      >
        <AvField
          label={t('admin.system_settings.helps.select_help_page')}
          className="org-inputs"
          name="id"
          type="select"
          validate={{
            required: {
              value: true,
              errorMessage: t('admin.system_settings.helps.help_page_required'),
            },
          }}
        >
          <option value="" disabled defaultValue>
            {t('formulary.placeholder.select_type')}
          </option>
          {this.helpPageList()}
        </AvField>

        <AvField
          label={t('admin.system_settings.helps.field_name')}
          className="org-inputs"
          name="fieldName"
          type="text"
          validate={{
            required: {
              value: true,
              errorMessage: t(
                'admin.system_settings.helps.field_name_required'
              ),
            },
          }}
        />

        <AvField
          label={t('admin.system_settings.helps.content')}
          className="org-inputs-textarea"
          name="contentTip"
          type="textarea"
          validate={{
            required: {
              value: true,
              errorMessage: t(
                'admin.system_settings.helps.field_name_required'
              ),
            },
          }}
        />

        <div className="model-buttons">
          <Button
            className="Secondary-Button"
            type="button"
            onClick={() => toggle()}
          >
            {t('actions.cancel')}
          </Button>
          <Button
            content={t('actions.create')}
            type="submit"
            className="Primary-Button"
            loading={hTipLoading}
            disabled={hTipLoading}
          />
        </div>
      </AvForm>
    );
  }
}

export class HelpList extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { helpPages, t } = this.props;
    return (
      <div className="help-list-container pb-3">
        {map(helpPages, (item, index) => {
          return (
            <HelpPageList
              key={index}
              helpPageItem={item}
              {...this.props}
              t={t}
            />
          );
        })}
      </div>
    );
  }
}

class HelpPageList extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      collapse: false,
    };
  }
  render() {
    const { helpPageItem, t } = this.props;
    return (
      <div className="accordion-container">
        <div className="gap-between-windows-help">
          <CustomAccordion
            title={helpPageItem.title}
            children={<HelpTipsView {...this.props} t={t} />}
          />
        </div>
      </div>
    );
  }
}
class HelpTipsViewBase extends PureComponent {
  renderColumns(activityHelpTips) {
    const { t, i18n } = this.props;

    const columns = [
      {
        title: (
          <div className="user-act-heading-container-custom-feature">
            <strong>{t('admin.system_settings.helps.id')}</strong>
          </div>
        ),
        render: (data) => {
          return <div>{data.id}</div>;
        },
        width: 1,
      },
      {
        title: (
          <div className="user-act-heading-container-custom-feature">
            <strong>
              {t('admin.system_settings.helps.field_name_header')}
            </strong>
          </div>
        ),
        render: (data) => {
          return <div>{data.fieldName}</div>;
        },
        width: 3,
      },
      {
        title: (
          <div className="user-act-heading-container-custom-feature">
            <strong>{t('common.created_date')}</strong>
          </div>
        ),
        render: (data) => {
          return (
            <div>
              {data.createdAt
                ? new Intl.DateTimeFormat(i18n.language, {
                    year: 'numeric',
                    month: 'short',
                    day: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: true,
                  }).format(new Date(data.createdAt))
                : '-'}
            </div>
          );
        },
        width: 2,
      },
      {
        title: (
          <div className="user-act-heading-container-custom-feature">
            <strong>{t('common.updated_date')}</strong>
          </div>
        ),
        render: (data) => {
          return (
            <div className="active-status-container">
              {data.updatedAt
                ? new Intl.DateTimeFormat(i18n.language, {
                    year: 'numeric',
                    month: 'short',
                    day: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: true,
                  }).format(new Date(data.updatedAt))
                : '-'}
            </div>
          );
        },
        width: 2,
      },
      {
        title: '',
        render: (data) => {
          return <EditHelpTip item={data} {...this.props} />;
        },
        width: 1,
      },
    ];

    if (!isMobile && !isTablet) {
      const contentColumn = {
        title: (
          <div className="user-act-heading-container-custom-feature">
            <strong>{t('admin.system_settings.helps.content')}</strong>
          </div>
        ),
        render: (data) => {
          return (
            <div>
              {data.content && data.content.length > 100 ? (
                <CustomTooltip
                  state={true}
                  contentObject={{
                    data: activityHelpTips,
                    key: data.id,
                  }}
                  position="top left"
                  wide="very"
                >
                  <span>{data.content.substring(0, 80) + '...'}</span>
                </CustomTooltip>
              ) : (
                data.content
              )}
            </div>
          );
        },
        width: 6,
      };

      columns.splice(1, 0, contentColumn); // added content column as second column if only desktop
    }

    return columns;
  }

  render() {
    let tips = [];
    const { t, activityHelpTips, helpPageItem } = this.props;

    return (
      <div className="view-accordion-com">
        <div className="scroll-accordion">
          {/* action buttons */}
          <div className="help-tip-right">
            <div className="margin-add-help-tip">
              <AddHelpTips helpPageItem={helpPageItem} {...this.props} />
            </div>
            <div className="margin-edit-help-page">
              <EditHelpPage helpPageItem={helpPageItem} {...this.props} />
            </div>
          </div>

          {/* list of help tips  */}
          {map(activityHelpTips, (item, i) => {
            if (helpPageItem.id !== item.helpPageId) return null;
            tips.push(item);
          })}
          <CustomTable
            header
            customClass="super-admin-table tbody-hover"
            columns={this.renderColumns(activityHelpTips)}
            data={tips}
            emptyMessage={t('common.no_tooltips')}
            keyExtractor={(item, index) => item.id}
          />
        </div>
      </div>
    );
  }
}
const HelpTipsView = withTranslation()(HelpTipsViewBase);

class EditHelpPage extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      form: {
        title: '',
      },
      content: '',
    };
  }

  editSelected(form) {
    this.setState({
      form,
      content: form.content,
    });
  }

  toggle() {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  }

  async handleValidSubmit(event, values) {
    try {
      const { updateHelpPage, helpPageItem } = this.props;
      const { content } = this.state;
      const data = { ...values, content };

      await updateHelpPage(helpPageItem.id, data);
      this.toggle();
    } catch (error) {
      console.error('EditHelpPage ~ handleValidSubmit ~ error :', error);
    }
  }

  render() {
    const { modal, form, content } = this.state;
    const { t, helpPageItem, updatePageLoading } = this.props;

    return (
      <Modal
        open={modal}
        onOpen={() => this.toggle()}
        closeIcon={
          <Icon
            onClick={() => this.toggle()}
            name="close"
            className="closeicon"
          />
        }
        size="small"
        trigger={
          <Button
            className="Secondary-Button"
            onClick={() => this.editSelected(helpPageItem)}
          >
            <Icon name="edit" />
            {t('admin.system_settings.helps.edit_help_page')}
          </Button>
        }
        className="edit-help-page"
      >
        <Modal.Header>
          {t('admin.system_settings.helps.edit_help_page')}
        </Modal.Header>
        <Modal.Content>
          <AvForm
            ref={(c) => (this.form = c)}
            onValidSubmit={(event, values) =>
              this.handleValidSubmit(event, values)
            }
            model={form}
            className="venue-form"
          >
            <AvField
              label={t('formulary.title')}
              className="org-inputs"
              name="title"
              type="text"
              validate={{
                required: {
                  value: true,
                  errorMessage: t('formulary.validation.title_required'),
                },
              }}
            ></AvField>

            <label>{t('formulary.content')}</label>
            <CKEditor
              name="content"
              editor={ClassicEditor}
              data={content}
              config={{
                plugins: [Essentials, Bold, Italic, List, Heading, Paragraph],
              }}
              onReady={(editor) => {}}
              onBlur={(event, editor) => {
                const content = editor.getData();
                this.setState({
                  content,
                });
              }}
            />

            <div className="model-buttons">
              <Button
                className="Secondary-Button"
                type="button"
                onClick={() => this.toggle()}
              >
                {t('actions.cancel')}
              </Button>
              <Button
                content={t('actions.save')}
                type="submit"
                className="Primary-Button"
                loading={updatePageLoading}
                disabled={updatePageLoading}
              />
            </div>
          </AvForm>
        </Modal.Content>
      </Modal>
    );
  }
}
class EditHelpTip extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      form: {
        angularState: '',
        fieldName: '',
        content: '',
      },
    };
  }

  toggle() {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  }

  editSelected(form) {
    this.setState({
      form,
    });
  }

  async handleValidSubmit(event, values) {
    try {
      const { putHelpTips, item } = this.props;

      await putHelpTips(item.id, values);
      this.toggle();
    } catch (error) {
      console.error('EditHelpTip ~ handleValidSubmit ~ error :', error);
    }
  }

  render() {
    const { modal, form } = this.state;
    const { t, item, helpPages, updateTipLoading } = this.props;

    return (
      <Modal
        open={modal}
        onOpen={() => this.toggle()}
        closeIcon={
          <Icon
            onClick={() => this.toggle()}
            name="close"
            className="closeicon"
          />
        }
        size="small"
        trigger={
          <label
            className="activity-actions-warn hover-btn mb-0 gap-icon"
            onClick={() => this.editSelected(item)}
          >
            {t('actions.edit')}
          </label>
        }
        className="edit-help-tip"
      >
        <Modal.Header>
          {t('admin.system_settings.helps.edit_help_tip')}
        </Modal.Header>
        <Modal.Content>
          <AvForm
            onValidSubmit={(event, values) =>
              this.handleValidSubmit(event, values)
            }
            className="venue-form"
            model={form}
          >
            <AvField
              label={t('admin.system_settings.helps.help_page_name')}
              className="org-inputs"
              name="helpPageId"
              type="select"
              validate={{
                required: {
                  value: true,
                  errorMessage: t(
                    'admin.system_settings.helps.help_page_is_required'
                  ),
                },
              }}
            >
              <option value="" defaultValue disabled>
                {t('formulary.placeholder.select_type')}
              </option>
              {map(helpPages, (help, i) => (
                <option key={i} value={help.id}>
                  {help.title}
                </option>
              ))}
            </AvField>

            <AvField
              label={t('admin.system_settings.helps.field_name_lower')}
              className="org-inputs"
              name="fieldName"
              type="text"
              validate={{
                required: {
                  value: true,
                  errorMessage: t(
                    'admin.system_settings.helps.field_name_lower_required'
                  ),
                },
              }}
            />
            <AvField
              label={t('admin.system_settings.helps.content')}
              className="org-inputs-textarea"
              name="content"
              type="textarea"
              validate={{
                required: {
                  value: true,
                  errorMessage: t(
                    'admin.system_settings.helps.field_name_lower_required'
                  ),
                },
              }}
            />

            <div className="model-buttons">
              <Button
                className="Secondary-Button"
                type="button"
                onClick={() => this.toggle()}
              >
                {t('actions.cancel')}
              </Button>
              <Button
                content={t('actions.save')}
                type="submit"
                className="Primary-Button"
                loading={updateTipLoading}
                disabled={updateTipLoading}
              />
            </div>
          </AvForm>
        </Modal.Content>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    helpPages: state.extra.helpPages,
    activityHelpTips: state.extra.activityHelpTips,
    hTipLoading: state.admin.hTipLoading,
    hPageLoading: state.admin.hPageLoading,
    updatePageLoading: state.admin.updatePageLoading,
    updateTipLoading: state.admin.updateTipLoading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getHelpPages,
      postHelpPage,
      postHelpTips,
      updateHelpPage,
      getActivityHelpTips,
      putHelpTips,
    },
    dispatch
  );
};

ParentHelpComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(ParentHelpComponent);

// Wrap with translation HOC
const ParentHelpComponentWithTranslation = (props) => {
  const { t } = useTranslation();
  return <ParentHelpComponent {...props} t={t} />;
};

export { ParentHelpComponentWithTranslation as ParentHelpComponent };
